module.exports = __webpack_public_path__ + "static_pc/img/3.07a1d737.jpg";